import infraImg from "./infra.png";
import cadastreImg from "./cadastre.png";
import planningImg from "./planning.png";

export { infraImg, cadastreImg, planningImg };
